import { useLocation } from 'react-router-dom';

const PageNotFound = () => {
    let location = useLocation();
    console.log(location)

    return(
        <h2>404: The page { location.pathname } was not found / does not exist</h2>
    );
};

export default PageNotFound;